import { JSX } from 'react'

import { IconProps } from '../../icon'

const Tiching: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 32 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M10.3623 5.52605C11.6327 5.52605 12.6253 4.4938 12.6253 3.26303C12.6253 1.99256 11.593 1 10.3623 1C9.0918 1 8.09924 2.03226 8.09924 3.26303C8.09924 4.5335 9.0918 5.52605 10.3623 5.52605Z'
      fill='#EA9F4C'
    />
    <path
      d='M19.1762 9.37713C20.4466 9.37713 21.4392 8.34487 21.4392 7.1141C21.4392 5.84363 20.4069 4.85107 19.1762 4.85107C17.9057 4.85107 16.9131 5.88333 16.9131 7.1141C16.9131 8.34487 17.9057 9.37713 19.1762 9.37713Z'
      fill='#EA9F4C'
    />
    <path
      d='M18.938 22.3995L19.0174 22.3201C18.938 22.3598 18.8585 22.4392 18.8188 22.4789C18.8188 22.4392 18.8585 22.4392 18.938 22.3995Z'
      fill='#989998'
    />
    <path
      d='M22.3127 18.1117C22.273 18.1514 22.273 18.2308 22.2333 18.2705C22.2333 18.1911 22.273 18.1514 22.3127 18.1117Z'
      fill='#989998'
    />
    <path
      d='M30.9678 25.7345L22.0745 19.1042L21.876 18.9454L21.9157 18.866C21.201 20.1761 20.2482 21.3275 19.0968 22.2804L19.2556 22.4392L27.474 29.9826L27.5137 30.0223C27.9504 30.3796 28.5062 30.6178 29.1018 30.6575C29.1415 30.6575 29.1812 30.6575 29.2209 30.6575C30.0149 30.6575 30.809 30.3002 31.3251 29.665C31.8015 29.1091 32 28.3945 31.9206 27.6799C31.9206 26.8461 31.5633 26.2109 30.9678 25.7345Z'
      fill='#129DB1'
    />
    <path
      d='M21.9156 18.866L21.995 18.7469C22.0744 18.5881 22.1538 18.4293 22.2332 18.2705C22.2729 18.2308 22.2729 18.1514 22.3126 18.1117C22.5906 17.5162 22.8288 16.8809 22.9876 16.2457C23.0273 16.0869 23.0273 15.8884 23.0273 15.7295C23.0273 14.4988 22.0347 13.5062 20.804 13.5062H20.7246C19.732 13.5062 18.8586 14.1812 18.6203 15.134C18.6203 15.134 18.6203 15.134 18.6203 15.1737C18.3424 16.1663 17.866 17.0794 17.2308 17.8338C15.8412 19.5013 13.8164 20.4541 11.6724 20.4541C10.005 20.4541 8.33746 19.8586 7.06699 18.7866C4.56575 16.6824 3.7717 13.1886 5.12158 10.2109C5.24068 9.93302 5.32009 9.61541 5.32009 9.29779C5.32009 8.06702 4.32753 7.07446 3.09676 7.07446C2.22332 7.07446 1.46897 7.55089 1.11165 8.30523C-1.11167 13.1092 0.158799 18.8263 4.24813 22.201C6.35235 23.9479 8.9727 24.9008 11.7121 24.9008C14.2928 24.9008 16.794 24.0273 18.8188 22.4789C18.8983 22.4392 18.9777 22.3598 19.0174 22.3201L19.0968 22.2407C20.2481 21.2879 21.201 20.1365 21.9156 18.866Z'
      fill='#24B6CA'
    />
  </svg>
)

export default Tiching
